import { jsx as _jsx } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsx("g", {
    children: /*#__PURE__*/_jsx("rect", {
      className: "line",
      x: "4",
      y: "15.2",
      width: "24",
      height: "1.6"
    })
  });
});